import React from 'react';
import { colors, typography, radius, spacing } from '../../../theme';

/**
 * Compact, tappable personal-records banner — opens the Records tab.
 */
const PRBanner = ({ totalPRs = 0, recentCount = 0, onTap }) => {
  if (totalPRs === 0) return null;

  const subtitle = recentCount > 0
    ? `${recentCount} in the last 30 days`
    : 'Strongest training block yet';

  return (
    <button
      onClick={onTap}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: spacing.md,
        width: '100%',
        padding: `${spacing.md} ${spacing.lg}`,
        marginBottom: spacing.lg,
        background: colors.goldDim,
        border: `1px solid rgba(212, 175, 55, 0.3)`,
        borderRadius: radius.card,
        cursor: 'pointer',
        textAlign: 'left',
      }}
    >
      <span style={{ fontSize: '20px', flexShrink: 0 }}>🏆</span>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ ...typography.body, fontWeight: '700', color: colors.text }}>
          {totalPRs} Personal Record{totalPRs !== 1 ? 's' : ''}
        </div>
        <div style={{ ...typography.caption, color: colors.textMuted, marginTop: '2px' }}>
          {subtitle}
        </div>
      </div>
      <span style={{ color: colors.textSubtle, fontSize: '18px', flexShrink: 0 }}>›</span>
    </button>
  );
};

export default PRBanner;
